<template>
  <div>
    <p class="input-label">{{ label }}</p>
    <div
      :class="[
        'radio-group',
        type === 'horizontal' ? 'horizontal-radio' : 'vertical-radio',
      ]"
    >
      <template v-if="styleType === 'button'">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="radio-container w-100"
          @click="handleClickOption(option)"
        >
          <!-- radio ui -->
          <div
            class="radio-indicator"
            :class="[
              { checked: option.value === value },
              { disabled: disabled },
            ]"
          >
            <div
              v-if="option.value === value"
              class="radio-indicator-checked"
            ></div>
          </div>
          <input
            type="radio"
            :ref="option.value + '-' + name"
            :id="option.value + '-' + name"
            :name="name"
            :value="option.value"
            :disabled="disabled"
            :checked="option.value === value"
            @click="handleClickButtonType"
            hidden
          />
          <label>{{ option.label }}</label>
        </div>
      </template>
      <div v-for="(option, index) in options" :key="index" v-else>
        <input
          type="radio"
          :id="option.value + '-' + name"
          :name="name"
          :value="option.value"
          :disabled="disabled"
          :checked="option.value === value"
          @input="$emit('change', $event.target.value)"
        />
        <label :for="option.value + '-' + name">{{ option.label }}</label>
      </div>
    </div>
    <small class="text-danger m-0" v-if="error">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: "InputRadio",
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "vertical",
      validator: (value) => ["vertical", "horizontal"].includes(value),
    },
    label: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    styleType: {
      type: String,
      default: "",
    },
    value: {
      type: String | Boolean,
      default: "",
    },
  },
  methods: {
    handleClickButtonType(event) {
      event.preventDefault();
      let value = event.target.value;
      if (value === "true") value = true;
      else if (value === "false") value = false;
      this.$emit("change", value);
    },
    handleClickOption(option) {
      this.$refs[option.value + "-" + this.name][0].click();
    },
  },
};
</script>

<style scoped>
label {
  color: #2e3646de;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
}

.input-label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  margin: 0;
  margin-bottom: 0.5rem;
}

.horizontal-radio {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.radio-group {
  height: 40px;
}

.vertical-radio {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

input[type="radio"] {
  accent-color: #3098f7;
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: translateY(3px);
}

input[type="radio"]:disabled {
  accent-color: #565f77;
}

.radio-container {
  border: 1px solid #d1d9e2;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  background: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.radio-container:has(input:checked) {
  border: 1px solid #3098f7;
}

.radio-container:has(input:disabled) {
  background-color: #f5f5f5;
  border-color: #d1d9e2;
  cursor: not-allowed;
}

label {
  cursor: pointer;
}

.radio-indicator {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2.5px solid #ffffff;
  background-color: #ffffff;
  box-shadow: 0 0 0 1px #4c51568a;
}

.radio-indicator.checked {
  border: 2.5px solid #ffffff;
  background-color: #3098f7;
  box-shadow: 0 0 0 1px #3098f7;
}

.radio-indicator.checked.disabled {
  border: 2.5px solid #ffffff;
  background-color: #565f77;
  box-shadow: 0 0 0 1px #565f77;
}

.radio-indicator.disabled {
  border: transparent;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/Input/Radio.vue